import React, { useEffect, useState } from "react";
import PageHeader from "../../components/Header/PageHeader";
import PageWrapper from "../../components/Page/PageWrapper";
import ProjectExpander from "../Project/ProjectExpander";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { IProject } from "../../reducers/project";
import { useDispatch, useSelector } from "react-redux";
import { getHistory } from "../../reducers/project/selectors";
import { ProjectActions } from "../../reducers/project/actionsNames";
import Scrollbars from "react-custom-scrollbars";
import content from "../../content";
import useDesktop from "../../components/Responsive/useDesktop";
import Visualizer from "../Visualizer/Visualizer";
import { AttributeHeader } from "../../components/Attributes/AttributesExpansion";
import { Button } from "./Creator";
import { projectLabel } from "../Project/ProjectExpander";
import { Stepper } from "../Project/Stepper";

const Label = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 26px;

  letter-spacing: -0.01em;

  color: #1e2029;
  display: flex;
  top: -55px;
  z-index: 30000;
  justify-content: center;
  position: relative;
  user-select: none;
`;

const Header = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 10px;
  letter-spacing: -0.01em;

  color: #1e2029;
`;

function ProjectHistory({}: IProjectsCart) {
    const history: IProject[] = useSelector(getHistory);

    const [preview, setPreview] = useState(0);
    const dispatch = useDispatch();

    const selectPreview = (i) => () => {
        setPreview(i);
    };

    useEffect(() => {
        const nextPreview = () => {
            setPreview(history[preview + 1] ? preview + 1 : 0);
        };
        const interval = setInterval(() => {
            nextPreview();
        }, 5000);
        return () => clearInterval(interval);
    }, [preview]);

    const reset = () => dispatch({ type: ProjectActions.Reset });

    const desktop = useDesktop();

    return (
        <>
            {/*<PageHeader*/}
            {/*  color={"#F9F9F9"}*/}
            {/*  height={"auto"}*/}
            {/*  header={content.getValue("header_history")}*/}
            {/*/>*/}
            <PageWrapper
                padding={desktop ? "20px 20px" : "16px 16px"}
                menu={
                    <>
                        <AttributeHeader
                            style={{
                                width: "200px",
                                margin: "0 auto",
                                marginBottom: "15px",
                                paddingTop: "50px",
                                justifyContent: "center",
                            }}
                        >
                            {content.getValue("selected_doors")}
                        </AttributeHeader>
                        <Visualizer
                            offsetHeight={215}
                            small={true}
                            preview={history[preview]?.components}
                        />
                        <Label>{projectLabel(history[preview])}</Label>
                        <Stepper
                            step={preview}
                            steps={history.length}
                            onClick={selectPreview}
                        />
                    </>
                }
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        height: `auto`,
                        maxHeight: `calc(100vh - ${desktop ? 162 : 145}px)`,
                        padding: "20px",
                        boxSizing: "border-box",
                        backgroundColor: "white",
                    }}
                >
                    <Header>{content.getValue("header_history")}</Header>
                    <Scrollbars
                        autoHeight={true}
                        autoHeightMin={0}
                        autoHeightMax={"calc(100vh - 360px)"}
                    >
                        {history.map((h) => (
                            <ProjectExpander history={true} project={h} />
                        ))}
                    </Scrollbars>
                    <Link to={"/"} onClick={reset}>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%",
                                height: "70px",
                                marginTop: "10px",
                                marginBottom: "25px",
                                border: "2px dashed #1B576A",
                                boxSizing: "border-box",
                                cursor: "pointer",
                                background: "rgba(27, 87, 106, 0.05)",
                            }}
                        >
                            <img
                                src={"/static/icon/ic20-plus-circle.svg"}
                                style={{ marginRight: "5px" }}
                            />

                            {content.getValue("button_new_project")}
                        </div>
                    </Link>
                </div>
            </PageWrapper>
        </>
    );
}

export interface IProjectsCart {}

export default ProjectHistory;
